import { Link } from 'react-router-dom';
import './Url.scss';
import React, { useEffect, useState } from 'react';

const UrlComponent = ({ data, direction }) => {
  const [positionHorizontal, setPositionHorizontal] = useState('');
  const [positionVertical, setPositionVertical] = useState('');
  const [url, setUrl] = useState('');
  const [urlText, setUrlText] = useState('');
  const [text, setText] = useState('');
  const [internalLink, setInternalLink] = useState({});

  useEffect(() => {
    if (data.interactionData.positionHorizontal) {
      setPositionHorizontal(data.interactionData.positionHorizontal);
      setPositionVertical(data.interactionData.positionVertical);
      setUrl(data.interactionData.url);
      setUrlText(data.interactionData.urlText);
      setText(data.interactionData.text);
      setInternalLink(data.interactionData.internalLink ? data.interactionData.internalLink : null);
    }
  }, [data]);

  return (
    <div className={`Url ${positionHorizontal} ${direction} ${positionVertical}`}>
      <p>{text}</p>
      <a href={url} target='_blank' rel='noreferrer'>
        {urlText}
      </a>
      {internalLink && (
        <div className='internalLink'>
          <p>{internalLink.title}</p>
          <Link className='link' to={internalLink.link}>
            {internalLink.linkTitle}
          </Link>
        </div>
      )}
    </div>
  );
};

export default UrlComponent;
